export enum AmericanFootballEventDetailId {
  // TODO: change common detail ids to `CommonEventDetailId`
  PeriodLength = 16,
  ExtraPeriodLength = 50,
  TimerDirection = 124,
}
